
import { Component, OnInit, Input, OnDestroy, OnChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Subscription, Observable } from 'rxjs';
 
import { Contact, Titre } from 'src/app/entity/Contact';
import { ConfirmedDialogComponent } from 'src/app/shared/dialogs';
import { Prospect, Pays } from 'src/app/entity/prospect';
import { Client } from 'src/app/entity/exhibitor';
import { ContactService } from 'src/app/service/contact.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { DelegateService } from 'src/app/service/delegate.service';
import { ContactsClientDialogComponent } from 'src/app/shared/dialogs/contacts-client-dialog/contacts-client-dialog.component';
import { Delegate } from 'src/app/entity/Delegate';
import { TitreService } from 'src/app/service/titre.service';
import { ProspectService } from 'src/app/service/prospect.service';
import { MailsService } from 'src/app/service/mails.service';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-delegate-form',
  templateUrl: './delegate-form.component.html',
  styleUrls: ['./delegate-form.component.css']
})
export class DelegateFormComponent implements OnInit, OnChanges {



  @Input() prospect: Prospect;
  @Input() selectedClient: Client;
  dataSource = new MatTableDataSource();
  uploadedFiles: any[];
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;

  selectedDelegate: Delegate;
  selectedDelegateId: number;
  payss: Observable<Pays[]>;
  positions: Titre[]
  positionsS: string[];
  ismail:boolean;
  constructor(private contactService: ContactService, private titreService: TitreService,private mailsService:MailsService,
    private dialog: MatDialog, private delegateService: DelegateService, private prospectService: ProspectService) {

  }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.findDelegates();
  }

  ngOnInit() {
  }

  save() {
    if (this.selectedDelegate && this.selectedDelegate.idDelegate) {


      this.delegateService.updateDelegate(this.selectedDelegate).subscribe(result => {

        this.findDelegates();
      })
    }

  }

  ngOnDestroy(): void {

  }

  removeDelegate(delegate: Delegate) {
    this.delegateService.deleteDelegate(delegate).subscribe(result => {
      this.findDelegates();
    })
  }



  filterPositions(filter: string) {
    if (filter && filter.length > 0)
      this.titreService.getAllDesignation(filter).subscribe(result => {
        this.positions = result;
        this.positionsS = []

        this.positions.forEach(element => {
          this.positionsS.push(element.designation)
        });
      });
  }

  filterPays(val: string): void {






    if (val && val.length > 0)
      this.payss = this.prospectService.findPaysByDesignation(val);




  }


  findDelegates() {


    this.delegateService.findByExhibitor(this.selectedClient.idClient).subscribe(data => {
      this.dataSource.data = data;
    })

  }

  select(delegate: Delegate) {
    this.selectedDelegate = delegate;
    this.selectedDelegateId = delegate.idDelegate;
    //console.log(delegate);

  }
  ajouterNouveau() {
    this.openContact();
  }

  openContact(): void {
    // Create configuration for the dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '500px';
    dialogConfig.width = '900px';
    dialogConfig.data = this.prospect;

    const dialogRef = this.dialog.open(ContactsClientDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.createNewDelegate(result);

      }
    });
  }


  createNewDelegate(contact: Contact) {
    this.selectedDelegate = new Delegate();
    this.selectedDelegate.nom = contact.nom;
    this.selectedDelegate.mobile = contact.mobile;
    this.selectedDelegate.mail = contact.mail;
    if (contact.titreId)
      this.selectedDelegate.position = contact.titreId.designation;
    else
      this.selectedDelegate.position = contact.titres;
     let pays: string;

    if (this.selectedClient.prospectId.pays)
      pays = this.selectedClient.prospectId.pays
    else if (this.selectedClient.prospectId.paysId)
      pays = this.selectedClient.prospectId.paysId.designationFr


      this.selectedDelegate.ordre=this.prospect.ordre;
    this.selectedDelegate.pays = pays
    this.selectedDelegate.entreprise = this.prospect.raisonSocial;
    this.selectedDelegate.idClient = this.selectedClient.idClient;
    this.delegateService.addDelegate(this.selectedDelegate).subscribe(result => {
      this.selectedDelegate = result;
      this.selectedDelegateId = this.selectedDelegate.idDelegate;
      this.findDelegates();
    }

    )
  }
  printBadge(){
    this.delegateService.print(this.selectedDelegate).subscribe( 
      (res: any) => {

        var filename = 'restfile.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');



        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

    }
   

    )
  }

  
  sendEBAdge( ) {


    this.uploadedFiles = []
    this.delegateService.print(this.selectedDelegate).subscribe( 
      (res) => {
        var filename = this.selectedDelegate.nom + '_e_badge.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        res.name = filename;
        this.uploadedFiles.push(res);
        this.mailsService.findodel(6).subscribe(result => {

          this.composeMailComponent.prepareEmailModelDelegate(result, this.selectedDelegate,   this.uploadedFiles)
        })

      }
    );

  }
}




